module.exports = __webpack_public_path__ + "static/media/testImage12.be3903a4.png";